var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row justify-center align-center navmenu"},[_c('v-icon',{staticClass:"mr-3"},[_vm._v("$vuetify.icons.docsIcon")]),_c('p',[_vm._v("Docs")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }